import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["d"]

import {ref} from "vue";
import {DropDownButtonComponent} from "@syncfusion/ej2-vue-splitbuttons";
import getGuid from "@/shared/utils/getGuid";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {ContextMenuComponent, MenuEventArgs} from "@syncfusion/ej2-vue-navigations";
import {enableRipple} from '@syncfusion/ej2-base';

interface Props {
  disabled?: boolean | string
  tooltip?: string
  items: IActionItem[]
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export interface IActionItem {
  id: string,
  text: string,
  mdiIcon?: string
  svgIcon?: string,
  visible: boolean,
}



export default /*@__PURE__*/_defineComponent({
  __name: 'SogCardActionMoreButton',
  props: {
    disabled: { type: [Boolean, String], default: false },
    tooltip: { default: undefined },
    items: {}
  },
  emits: ["select"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

enableRipple(true);


const props = __props

const _emits = __emit;


const obj = ref<InstanceType<typeof DropDownButtonComponent> | null>(null)
const _menu = ref<InstanceType<typeof ContextMenuComponent> | null>(null)
const _id = ref(getGuid())


const focus = () => {
  obj.value?.focus();
}

__expose({
  focus
})

function onMore() {
  const a = document.getElementById(_id.value);
  if (!a)
    return
  const rect = a.getBoundingClientRect();
  _menu.value.open(rect.bottom, rect.left)
}

function beforeOpen() {
  const array: string[] = []
  props.items.filter(t => t.visible).map(t => array.push(t.text))
  _menu.value.showItems(array)
  array.length = 0;
  props.items.filter(t => !t.visible).map(t => array.push(t.text))
  _menu.value.hideItems(array)
}

function beforeItemRender(args: any) {

  /*
      <svg
      width="24"
      height="24"
    >
      <path :d="mdiAccount" />
    </svg>

  * */
  /*
  const svg = document.createElement('svg');
  const path = document.createElement('path');
  path.setAttribute("d",mdiAccount)

  svg.appendChild(path)
*/

  const a = document.getElementById(args.item.id);

  args.element.innerText = ""


  const div = document.createElement("div")
  div.setAttribute("class", "sog-card-action-more-button");
  div.setAttribute("style", "display:flex; ");

  if (a) {
    div.appendChild(a)
  }
  const text = document.createElement("span")
  text.innerText = args.item.text
  div.appendChild(text)
  args.element.appendChild(div)

}

function onSelect(event: MenuEventArgs) {
  if (event.item.id) {
    _emits('select', event.item.id)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCardActionButton, {
    id: _id.value,
    ref_key: "obj",
    ref: obj,
    "mdi-icon": "mdi-dots-vertical",
    disabled: __props.disabled,
    tooltip: __props.tooltip,
    style: {"align-self":"flex-end"},
    class: "oles",
    onClick: onMore
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(ContextMenuComponent), {
        ref_key: "_menu",
        ref: _menu,
        items: __props.items,
        "before-item-render": beforeItemRender,
        "before-open": beforeOpen,
        class: "oles",
        onSelect: onSelect
      }, null, 8, ["items"]),
      _withDirectives(_createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items.filter(t=>t.svgIcon), (svg) => {
          return (_openBlock(), _createElementBlock("svg", {
            id: svg.id,
            key: svg,
            width: "24",
            height: "24",
            style: {"align-self":"center","margin-right":"3px"}
          }, [
            _createElementVNode("path", {
              d: svg.svgIcon
            }, null, 8, _hoisted_2)
          ], 8, _hoisted_1))
        }), 128))
      ], 512), [
        [_vShow, false]
      ])
    ]),
    _: 1
  }, 8, ["id", "disabled", "tooltip"]))
}
}

})